import { type FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoute } from '@common/app/routes';
import { useCountDownTimer } from '@common/hooks/count-down-timer';
import { type ActiveBoostItemProps } from '@common/types/components';
import { useModal } from '@context/ModalContext';
import { clearQuarryBoost } from '@redux/reducers/quarryReducer';
import { selectQuarryByIdOrName } from '@redux/selectors/quarrySelectors';
import { useAppDispatch, useAppSelector } from '@redux/store';

import { ActiveBoostItem } from '../ActiveBoostItem';

const QuarryActiveBoostItem: FC<ActiveBoostItemProps> = ({
  id,
  expiresInSeconds,
  plantId,
  boostType,
  effectMultiplier,
}) => {
  const dispatch = useAppDispatch();
  const quarry = useAppSelector((state) => selectQuarryByIdOrName(state, id));
  const seconds = useCountDownTimer(expiresInSeconds);
  const navigate = useNavigate();
  const { setIsQuarryBoostModalOpen } = useModal();

  useEffect(() => {
    if (seconds === 0 && seconds !== expiresInSeconds) {
      dispatch(clearQuarryBoost({ plantId, boostType }));
    }
  }, [expiresInSeconds, seconds]);

  const onClick = (): void => {
    navigate(AppRoute.RESOURCES + `/mineResource/${id}`);
    setIsQuarryBoostModalOpen(false);
  };

  if (!quarry || !expiresInSeconds) {
    return null;
  }

  return (
    <div onClick={onClick}>
      <ActiveBoostItem
        seconds={seconds}
        itemName={quarry.name}
        effectMultiplier={effectMultiplier}
      />
    </div>
  );
};

export { QuarryActiveBoostItem };
